// extracted by mini-css-extract-plugin
export default {"root":"Dropdown_root__ZN574","fade-in":"Dropdown_fade-in__CjPJJ","dropdown":"Dropdown_dropdown__QEFz6","paper":"Dropdown_paper__gprvw","backdrop":"Dropdown_backdrop__3WPEZ"};